import { render, staticRenderFns } from "./VideoPlayerDialog.vue?vue&type=template&id=ba6c0558&scoped=true"
import script from "./VideoPlayerDialog.vue?vue&type=script&lang=js"
export * from "./VideoPlayerDialog.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayerDialog.vue?vue&type=style&index=0&id=ba6c0558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6c0558",
  null
  
)

export default component.exports